<template>
  <LayoutGradient :title="pageTitle" icon="fa-file-signature">
    <template v-slot:headerRight>
      <b-btn variant="outline-info" @click="$router.back()">
        <i class="fas fa-arrow-left"/> {{ $t('sideBar.voltar') }}
      </b-btn>
    </template>
    <b-overlay :show="isLoading" class="m-3 mt-n10" no-center>
      <template v-slot:overlay>
        <div class="d-flex mt-5">
          <div class="m-auto">
            <b-icon icon="stopwatch" font-scale="3" animation="cylon"/>
            <p>Carregando...</p>
          </div>
        </div>
      </template>
      <b-card>
        <b-form @submit="onSubmit">
          <b-form-group label-cols-lg="2"
                        :label="$t('tuevs.exams.form.fieldsets.informacoes')"
                        label-size="lg"
                        label-class="font-weight-bold pt-0" class="border-bottom-info mb-5">
            <b-form-group
                :label="$t('tuevs.exams.form.fields.status.label')"
                label-for="input-status"
                :description="$t('tuevs.exams.form.fields.status.description')"
                label-cols-sm="3"
                label-align-sm="right">
              <b-form-checkbox id="input-status" v-model="exam.status" size="lg" switch/>
            </b-form-group>
            <b-form-group
                label-cols-sm="3"
                label-align-sm="right"
                :label="$t('tuevs.exams.form.fields.ordem_resultado.label')"
                label-for="input-tipos">
              <SelectComponent
                  id="input-tipos"
                  :model="store_exam.direction"
                  :options="directions"
                  @input="evt => setExam('direction', evt)"
              />
            </b-form-group>
            <b-form-group
                label-cols-sm="3"
                label-align-sm="right" :label="$t('tuevs.exams.form.fields.nome.label')"
                label-for="input-name">
              <b-form-input id="input-name" v-model="store_exam.name" required/>
            </b-form-group>
            <b-form-group
                label-cols-sm="3"
                label-align-sm="right" :label="$t('tuevs.exams.form.fields.codigo.label')"
                label-for="input-codigo">
              <b-form-input id="input-codigo" v-model="store_exam.external_code" required/>
            </b-form-group>
          </b-form-group>

          <b-form-group label-cols-lg="2"
                        :label="$t('tuevs.exams.form.fieldsets.composicao')"
                        label-size="lg"
                        label-class="font-weight-bold pt-0"
                        class="border-bottom-info mb-5">
            <b-form-group
                label-cols-sm="3"
                label-align-sm="right"
                :label="$t('tuevs.exams.form.fields.componente.label')"
                label-for="input-componente">
              <b-overlay :show="store_components_loading">
                <SelectComponent
                    id="input-componente"
                    :model="store_exam.component"
                    :options="components | idNameToValueLabel"
                    @search="evt => {autocomplete('tuevs/component', evt)}"
                    @input="evt => setExam('component', evt)"
                />
              </b-overlay>
            </b-form-group>
            <b-form-group
                label-cols-sm="3"
                label-align-sm="right"
                :label="$t('tuevs.exams.form.fields.material.label')"
                label-for="input-material">
              <b-overlay :show="store_materials_loading">
                <SelectComponent
                    id="input-material"
                    :model="store_exam.specimen"
                    :options="materials | idNameToValueLabel"
                    @search="evt => {autocomplete('tuevs/material', evt)}"
                    @input="evt => setExam('specimen', evt)"
                />
              </b-overlay>
            </b-form-group>            
            <b-form-group
                label-cols-sm="3"
                label-align-sm="right"
                :label="$t('tuevs.exams.form.fields.tempo.label')"
                label-for="input-tempos">
              <b-overlay :show="store_times_loading">
                <SelectComponent
                    id="input-tempos"
                    :model="store_exam.time"
                    :options="times | idNameToValueLabel"
                    @search="evt => {autocomplete('tuevs/time', evt)}"
                    @input="evt => setExam('time', evt)"
                />
              </b-overlay>
            </b-form-group>
            <b-form-group
                label-cols-sm="3"
                label-align-sm="right"
                :label="$t('tuevs.exams.form.fields.escala.label')"
                label-for="input-escala">
              <b-overlay :show="store_scales_loading">
                <SelectComponent
                    id="input-escala"
                    :model="store_exam.scale"
                    :options="scales | idNameToValueLabel"
                    @search="evt => {autocomplete('tuevs/scale', evt)}"
                    @input="evt => setExam('scale', evt)"
                />
              </b-overlay>
            </b-form-group>
          </b-form-group>
          <b-form-group label-cols-lg="2"
                        :label="$t('tuevs.exams.form.fieldsets.metodo')"
                        label-size="lg"
                        label-class="font-weight-bold pt-0"
                        class="border-bottom-info mb-5">
            <b-form-group
                label-cols-sm="3"
                label-align-sm="right"
                :label="$t('tuevs.exams.form.fields.adicionar_metodo')"
                label-for="input-metodo">

              <b-overlay :show="store_methods_loading">
                <SelectComponent
                    id="input-metodo"
                    :model="inputMethod"
                    :options="methods | idNameToValueLabel"
                    @search="evt => {autocomplete('tuevs/method', evt)}"
                    @input="evt => {includeMethod('addMethod', evt)}"
                />
              </b-overlay>
              <b-table v-if="methodEntities && methodEntities.length > 0"
                        thead-class="d-none"
                        :fields="['id','name']"
                        :items="methodEntities"
                        tbody-tr-class="float-left">
                <template v-slot:cell(id)="linha">
                  <b-button
                      variant="outline-danger"
                      @click="removeMethod(linha.item);"
                      pill><i class="fas fa-minus"/>
                  </b-button>
                </template>
              </b-table>
            </b-form-group>
          </b-form-group>
          <b-form-group label-cols-lg="2"
                        :label="$t('tuevs.exams.form.fieldsets.materiais_possiveis')"
                        label-size="lg"
                        label-class="font-weight-bold pt-0"
                        class="border-bottom-info mb-5">
            <b-form-group
                label-cols-sm="3"
                label-align-sm="right"
                :label="$t('tuevs.exams.form.fields.possible_specimens.label')">
              <b-overlay :show="store_link_integrations_loading">
                <div v-if="possibleSpecimens.length > 0" class="d-flex mb-1">
                  <div class="flex-grow-1 mr-2 font-weight-bold">
                    {{ $t('tuevs.exams.form.fields.possible_specimens.integration_label') }}
                  </div>
                  <div class="flex-grow-1 mr-2 font-weight-bold">
                    {{ $t('tuevs.exams.form.fields.possible_specimens.material_label') }}
                  </div>
                  <div class="invisible">
                    <b-button pill><i class="fas fa-minus"/></b-button>
                  </div>
                </div>
                <div v-for="(row, index) in possibleSpecimens" :key="`possible-specimen-${row._uid}`"
                     class="d-flex align-items-start mb-2">
                  <div class="flex-grow-1 mr-2">
                    <SelectComponent
                        :id="`input-possible-integration-${index}`"
                        :model="row.integration"
                        :options="linkIntegrations | idNameToValueLabel"
                        @input="evt => setPossibleSpecimenIntegration(index, evt)"
                    />
                  </div>
                  <div class="flex-grow-1 mr-2">
                    <b-form-input
                        :id="`input-possible-material-${index}`"
                        v-model="row.possible_material"
                        maxlength="255"
                        :placeholder="$t('tuevs.exams.form.fields.possible_specimens.material_placeholder')"
                    />
                  </div>
                  <b-button
                      variant="outline-danger"
                      @click="removePossibleSpecimen(index)"
                      pill><i class="fas fa-minus"/>
                  </b-button>
                </div>
                <b-button variant="outline-success" @click="addPossibleSpecimen">
                  <i class="fas fa-plus"/> {{ $t('tuevs.exams.form.fields.possible_specimens.adicionar') }}
                </b-button>
              </b-overlay>
            </b-form-group>
          </b-form-group>
          <b-form-group label-cols-lg="2"
                        :label="$t('tuevs.exams.form.fieldsets.mnemonicos')"
                        label-size="lg"
                        label-class="font-weight-bold pt-0"
                        class="border-bottom-info mb-5">
            <b-form-group
                label-cols-sm="3"
                label-align-sm="right"
                :label="$t('tuevs.exams.form.fields.mnemonico_veus_exam.label')"
                label-for="input-codigo">
              <b-form-input id="input-codigo" v-model="store_exam.mnemonic_veus_exam" type="text"/>
            </b-form-group>
            <b-form-group
                label-cols-sm="3"
                label-align-sm="right"
                :label="$t('tuevs.exams.form.fields.mnemonico_veus_subexam.label')"
                label-for="input-codigo">
              <b-form-input id="input-codigo" v-model="store_exam.mnemonic_veus_subexam" type="text"/>
            </b-form-group>
          </b-form-group>

          <b-form-group label-cols-lg="2"
                        :label="$t('tuevs.exams.form.fieldsets.sub_exames')"
                        label-size="lg"
                        label-class="font-weight-bold pt-0"
                        class="border-bottom-info mb-5">
            <b-form-group
                label-cols-sm="3"
                label-align-sm="right"
                :label="$t('tuevs.exams.form.fields.adicionar_sub_exame_form.label')"
                label-for="input-subexame">
              <b-overlay :show="store_exams_loading">
                <SelectComponent
                    id="input-subexame"
                    :model="subExamModel"
                    :options="exams | idNameToValueLabel"
                    @search="evt => {autocomplete('tuevs/exams', evt)}"
                    @input="evt => {addElement('children', { id: evt.value, name: evt.label})}"
                />
              </b-overlay>
              <b-table v-if="exam && exam.children && exam.children.length > 0"
                       thead-class="d-none"
                       :fields="['id','name']"
                       :items="exam.children"
                       tbody-tr-class="float-left">
                <template v-slot:cell(id)="linha">
                  <b-button
                      variant="outline-danger"
                      @click="removeElement('children', linha.item)"
                      pill><i class="fas fa-minus"/>
                  </b-button>
                </template>
              </b-table>
            </b-form-group>
          </b-form-group>

          <b-form-group label-cols-lg="2"
                        :label="$t('tuevs.exams.form.fieldsets.sinonimos')"
                        label-size="lg"
                        label-class="font-weight-bold pt-0"
                        class="border-bottom-info mb-5">
            <b-form-group
                label-cols-sm="3"
                label-align-sm="right"
                :label="$t('tuevs.exams.form.fields.adicionar_sinonimos_form.label')"
                label-for="input-sinonimos">
              <b-input-group>
                <b-input-group-prepend>
                  <b-button
                      variant="outline-success"
                      @click="addElement('synonyms', {id: null, name: input_sinonimo})">
                    <i class="fas fa-plus"/></b-button>
                </b-input-group-prepend>
                <b-form-input id="input-sinonimos" v-model="input_sinonimo"/>
              </b-input-group>
              <b-table v-if="exam && exam.synonyms && exam.synonyms.length > 0"
                       thead-class="d-none"
                       :fields="['id','name']"
                       :items="exam.synonyms"
                       tbody-tr-class="float-left">
                <template v-slot:cell(id)="linha">
                  <b-button
                      variant="outline-danger"
                      @click="removeElement('synonyms', linha.item)"
                      pill><i class="fas fa-minus"/>
                  </b-button>
                </template>
              </b-table>
            </b-form-group>
          </b-form-group>

          <b-form-group label-cols-lg="2"
                        :label="$t('tuevs.exams.form.fieldsets.loinc')"
                        label-size="lg"
                        label-class="font-weight-bold pt-0"
                        class="border-bottom-info mb-5">
            <b-table v-if="loincs && loincs.length > 0"
                     thead-class="d-none"
                     :fields="['loinc', 'fully_specified_name', 'long_common_name', 'short_name', 'display_name']"
                     :items="loincs"/>
          </b-form-group>

          <b-form-group label-cols-lg="2"
                        :label="$t('tuevs.exams.form.fieldsets.bypass')"
                        label-size="lg"
                        label-class="font-weight-bold pt-0"
                        class="border-bottom-info mb-5">                        
            <b-form-group
              :label="$t('tuevs.exams.form.fields.specimen_complement.label')"
              label-for="input-bypass_specimen_complement"
              :description="$t('tuevs.exams.form.fields.specimen_complement.description')"
              label-cols-sm="3"
              label-align-sm="right">              
              <b-form-checkbox id="input-bypass_specimen_complement" v-model="exam.bypass_specimen_complement" size="lg" switch/>
            </b-form-group>
          </b-form-group>

          <b-form-group label-cols-lg="2"
                        :label="$t('tuevs.exams.form.fieldsets.compound')"
                        label-size="lg"
                        label-class="font-weight-bold pt-0"
                        class="border-bottom-info mb-5"
                        v-if="exam && exam.children && exam.children.length > 0">
            <b-form-group
              :label="$t('tuevs.exams.form.fields.compound.label')"
              label-for="input-compound"
              :description="$t('tuevs.exams.form.fields.compound.description')"
              label-cols-sm="3"
              label-align-sm="right">
              <b-form-checkbox id="input-compound" v-model="exam.compound" size="lg" switch/>
            </b-form-group>
          </b-form-group>

          <b-button type="submit" variant="success">
            <i class="fas fa-save"/> {{ $t('tuevs.exams.form.fields.botao_salvar') }}
          </b-button>
        </b-form>
      </b-card>
    </b-overlay>
  </LayoutGradient>
</template>

<script>
import LayoutGradient from "@/templates/LayoutGradient";
import SelectComponent from "@/components/SelectComponent";
import ExamRepository from '@/repositories/tuevs/ExamRepository'
import {mapActions, mapGetters} from "vuex";

export default {
  name: "Form",
  components: {
    SelectComponent,
    LayoutGradient
  },
  computed: {
    ...mapGetters({
      store_exam: 'tuevs/exams/current',
      store_isLoading: 'tuevs/exams/isLoading',
      components: 'tuevs/component/all',
      store_components_loading: 'tuevs/component/isLoading',
      materials: 'tuevs/material/all',
      store_materials_loading: 'tuevs/material/isLoading',
      methods: 'tuevs/method/all',
      store_methods_loading: 'tuevs/method/isLoading',
      examMethods: 'tuevs/exams/allMethods',
      times: 'tuevs/time/all',
      store_times_loading: 'tuevs/time/isLoading',
      scales: 'tuevs/scale/all',
      store_scales_loading: 'tuevs/scale/isLoading',
      exams: 'tuevs/exams/all',
      store_exams_loading: 'tuevs/exams/isLoading',
      examPossibleSpecimens: 'tuevs/exams/allPossibleSpecimens',
      linkIntegrations: 'integration/linkIntegrations',
      store_link_integrations_loading: 'integration/isLoading',
    }),
    pageTitle() {
      if (this.exam_id) return this.$t('tuevs.exams.form.titulo_pagina.editar')
      return this.$t('tuevs.exams.form.titulo_pagina.criar')
    },
    isLoading() {
      return !(this.mounted && this.store_isLoading === false)
    },
    exam() {
      return {
        ...this.store_exam,
        tuevs_component_id: this.store_exam.component ? this.store_exam.component.value : null,
        tuevs_specimen_id: this.store_exam.specimen ? this.store_exam.specimen.value : null,
        tuevs_time_id: this.store_exam.time ? this.store_exam.time.value : null,
        tuevs_scale_id: this.store_exam.scale ? this.store_exam.scale.value : null,
        orderObservation: this.store_exam.direction ? this.store_exam.direction.value : null,
        children: this.children,
        synonyms: this.synonyms,
      }
    },
    methodEntities() {
      let method = [];
      if (this.examMethods && this.examMethods.length > 0) {
        method = this.examMethods.map((methodEntity) => {
          return {
            id: methodEntity.id,
            name: methodEntity.name
          }
        });
      }

      return method.concat(this.addMethod.map(item => {
        return {
          id: item.value,
          name: item.label
        }
      }));
    }
  },
  data() {
    return {
      exam_id: null,
      mounted: false,
      subExamModel: {},
      inputMethod: {},
      children: [],
      input_sinonimo: '',
      synonyms: [],
      loincs: [],
      addMethod: [],
      possibleSpecimens: [],
      possibleSpecimenUid: 0,
      directions: [
        {label: this.$t('tuevs.exams.form.fields.directions.ordem'), value: 'order'},
        {label: this.$t('tuevs.exams.form.fields.directions.resultado'), value: 'observation'},
        {label: this.$t('tuevs.exams.form.fields.directions.ambos'), value: 'both'}
      ]
    }
  },
  methods: {
    ...mapActions([
      'tuevs/exams/listOne',
      'tuevs/component/search',
      'tuevs/material/search',
      'tuevs/method/search',
      'tuevs/time/search',
      'tuevs/scale/search',
      'tuevs/exams/search',
      'tuevs/exams/listMethods',
      'tuevs/exams/listPossibleSpecimens',
      'integration/searchLink',
    ]),
    async autocomplete(entityString, string) {
      if (string && string.length >= 3 && !this.awaitingSearch) {
        setTimeout(() => {
          // TODO: REMOVER E PASSAR CASE SENSITIVE PARA P BANCO
          this.temporallyStringPrepareToSQL('name', string).map(async array => {
            await this[`${entityString}/search`]({filters: [array]})
          })
          this.awaitingSearch = false
        }, 1000)
        this.awaitingSearch = true
      }
    },
    // TODO: REMOVER E PASSAR CASE SENSITIVE PARA P BANCO
    temporallyStringPrepareToSQL(field, valueTyped) {
      const string = valueTyped.toLowerCase()
      return [
        [field, 'LIKE', '%' + valueTyped + '%'],
        [field, 'LIKE', '%' + string + '%'],
        [field, 'LIKE', '%' + string.toUpperCase() + '%'],
        [field, 'LIKE', '%' + string.charAt(0).toUpperCase() + string.slice(1) + '%'],
      ]
    },
    setExam(key, value) {
      this.$store.commit('tuevs/exams/setCurrent', {...this.exam, [key]: value})
    },
    addElement(array, element) {
      this[array] = [...this[array], element];
      this.subExamModel = {};      
    },
    includeMethod(array, element) {
      if (this.methodEntities.find(e => e.id === element.value)) {
        this.$snotify.warning(this.$t('tuevs.exams.form.fields.metodo.warning.duplicated'))        
        this.inputMethod = {};
        return
      }
      
      this[array] = [...this[array], element];
      this.inputMethod = {};
    },
    removeElement(array, element) {
      this[array] = this[array].filter(e => {
        return e !== element
      })
    },
    removeMethod(element) {
      let examMethodsNew = this.examMethods.filter(e => {
        return e.id !== element.id
      })

      this.$store.commit('tuevs/exams/setAllMethods', [
          ...examMethodsNew
      ])
      
      this.addMethod = this.addMethod.filter(e => {
        return e.value !== element.id
      })
    },
    nextPossibleSpecimenUid() {
      this.possibleSpecimenUid += 1
      return this.possibleSpecimenUid
    },
    addPossibleSpecimen() {
      this.possibleSpecimens = [
        ...this.possibleSpecimens,
        {_uid: this.nextPossibleSpecimenUid(), integration: null, possible_material: ''}
      ]
    },
    removePossibleSpecimen(index) {
      this.possibleSpecimens = this.possibleSpecimens.filter((e, i) => i !== index)
    },
    setPossibleSpecimenIntegration(index, value) {
      const selectedId = value && value.value ? value.value : null
      const alreadyUsed = selectedId && this.possibleSpecimens.some((row, i) => (
        i !== index && row.integration && row.integration.value === selectedId
      ))
      if (alreadyUsed) {
        this.$snotify.warning(this.$t('tuevs.exams.form.fields.possible_specimens.warning.duplicated'))
        this.possibleSpecimens = this.possibleSpecimens.map((row, i) => (
          i === index ? {...row, integration: null} : row
        ))
        return
      }
      this.possibleSpecimens = this.possibleSpecimens.map((row, i) => {
        if (i === index) {
          return {...row, integration: value}
        }
        return row
      })
    },
    buildPossibleSpecimensPayload() {
      const rows = this.possibleSpecimens
        .map(row => {
          const hasIntegration = !!(row.integration && row.integration.value)
          return {
            hasIntegration,
            value: hasIntegration ? row.integration.value : null,
            material: row.possible_material ? row.possible_material.trim() : ''
          }
        })
        .filter(row => row.hasIntegration || row.material !== '')

      const incomplete = rows.some(row => !row.hasIntegration || row.material === '')
      if (incomplete) {
        this.$snotify.warning(this.$t('tuevs.exams.form.fields.possible_specimens.warning.incomplete'))
        return null
      }

      const integrationIds = rows.map(row => row.value)
      const hasDuplicated = integrationIds.some((id, index) => integrationIds.indexOf(id) !== index)
      if (hasDuplicated) {
        this.$snotify.warning(this.$t('tuevs.exams.form.fields.possible_specimens.warning.duplicated'))
        return null
      }

      return rows.map(row => ({
        vns_integration_id: row.value,
        possible_material: row.material
      }))
    },
    async onSubmit(evt) {
      evt.preventDefault()
      if (this.$route.params.id) {
        this.update()
      } else {
        this.create()
      }
    },
    create() {
      const possibleSpecimens = this.buildPossibleSpecimensPayload()
      if (possibleSpecimens === null) {
        return
      }
      if (!this.exam.compound) {
        this.exam.compound = false;
      }
      ExamRepository.post({
        ...this.exam,
        children: this.exam.children.map(e => {
          return e.id;
        }),
        synonyms: this.exam.synonyms.map(s => {
          return s.name;
        }),
        methods: this.methodEntities.map(m => {
          return m.id;
        }),
        possible_specimens: possibleSpecimens
      }).then(() => {
        this.$snotify.success(this.$t('tuevs.exams.form.create.success'))
        this.$router.push({name: 'tuevs.exams'})
      }).catch(error => {
        this.$snotify.error(this.$t('tuevs.exams.form.create.error'))
        if (error.response.status === 422) {
          ExamRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    },
    update() {
      const possibleSpecimens = this.buildPossibleSpecimensPayload()
      if (possibleSpecimens === null) {
        return
      }
      if (!this.exam.compound) {
        this.exam.compound = false;
      }
      ExamRepository.put(
          this.exam_id,
          {
            ...this.exam,
            children: this.exam.children.map(e => {
              return e.id;
            }),
            synonyms: this.exam.synonyms.map(s => {
              return s.name;
            }),
            methods: this.methodEntities.map(m => {
              return m.id;
            }),
            possible_specimens: possibleSpecimens
          }
      ).then(() => {
        this.$snotify.success(this.$t('tuevs.exams.form.update.success'))
        this.$router.push({name: 'tuevs.exams'})
      }).catch(error => {
        this.$snotify.error(this.$t('tuevs.exams.form.update.error'))
        if (error.response.status === 422) {
          ExamRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    }
  },
  async mounted() {
    this.$store.commit('tuevs/exams/setCurrent', {status: false})
    await this['integration/searchLink']()

    if (this.$route.params.id) {
      this.exam_id = this.$route.params.id
      await this['tuevs/exams/listOne'](this.$route.params.id)
      await this['tuevs/exams/listMethods'](this.exam_id)
      await this['tuevs/exams/listPossibleSpecimens'](this.exam_id)
      this.possibleSpecimens = (this.examPossibleSpecimens || []).map(item => {
        const integration = this.linkIntegrations.find(i => i.id === item.vns_integration_id)
        return {
          _uid: this.nextPossibleSpecimenUid(),
          integration: integration
              ? {label: integration.name, value: integration.id}
              : {label: this.$t('tuevs.exams.form.fields.possible_specimens.integration_unavailable'), value: item.vns_integration_id},
          possible_material: item.possible_material
        }
      })

      let exam = this.store_exam
      if (exam.orderObservation) {
        this.directions = [...this.directions] //forceUpdate options
        exam.direction = this.directions.find(obj => obj.value === exam.orderObservation)
      }
      if (exam.component) {
        this.$store.commit('tuevs/component/setAll', [
          exam.component,
          ...this.components.filter(obj => obj.id !== exam.component.id)
        ])
        exam.component = {label: exam.component.name, value: exam.component.id}
      }
      if (exam.specimen) {
        this.$store.commit('tuevs/material/setAll', [
          exam.specimen,
          ...this.materials.filter(obj => obj.id !== exam.specimen.id)
        ])
        exam.specimen = {label: exam.specimen.name, value: exam.specimen.id}
      }
      if (exam.time) {
        this.$store.commit('tuevs/time/setAll', [
          exam.time,
          ...this.times.filter(obj => obj.id !== exam.time.id)
        ])
        exam.time = {label: exam.time.name, value: exam.time.id}
      }
      if (exam.scale) {
        this.$store.commit('tuevs/scale/setAll', [
          exam.scale,
          ...this.scales.filter(obj => obj.id !== exam.scale.id)
        ])
        exam.scale = {label: exam.scale.name, value: exam.scale.id}
      }
      if (this.store_exam && this.store_exam.children && this.store_exam.children.length > 0) {
        this.children = this.store_exam.children.map(ent => {
          return {
            name: ent.name,
            id: ent.id
          }
        })
      }
      this.synonyms = await ExamRepository.fetchSynonyms(this.exam_id).then(response => {
        return response.data.data.map(s => {
          return {id: null, name: s}
        })
      })
      this.loincs = await ExamRepository.fetchLoincs(this.exam_id).then(response => {
        return response.data.data
      })
      this.$store.commit('tuevs/exams/setCurrent', exam)
    }
    this.mounted = true
    this['tuevs/component/search']()
    this['tuevs/material/search']()
    this['tuevs/method/search']()
    this['tuevs/time/search']()
    this['tuevs/scale/search']()
    this['tuevs/exams/search']()
  }
}
</script>

<style lang="scss" scoped>
</style>
